export default function TrainerListingCard({ children }) {
  return (
    <div className="rounded-lg lg:rounded-xl xl:rounded-2xl focus:outline-none shadow hover:shadow-xl bg-white relative transition ease-in-out duration-300 min-h-full flex flex-col">
      <div className="flex flex-col relative z-10 flex-1">{children}</div>
    </div>
  );
}
